<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{
          path: '/raceManagement/individual_management/individual_manage_homeview/individual_race_management',
        }"
        >个人赛赛务工具</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{
          path: '/raceManagement/individual_management/raceManagement_childview/individual_racing_tool/examination_national_room_list',
        }">线下选考场</el-breadcrumb-item>
      <el-breadcrumb-item>选手管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 考场筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">选手筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="90px"
        ref="queryFormRef"
      >
        <el-row :gutter="50">
          <el-col :span="6">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系方式" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="学校名称" prop="schoolName">
              <el-input
                v-model="queryForm.schoolName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="handleToSearch"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="handleToReset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 考场管理 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col :span="12">
          <span class="title_class">选手管理</span>
        </el-col>
        <el-col :span="12">
          <div class="div_algin_right">
            <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportTable()"
            >导出考生</el-button
          >            <!-- <el-button type="primary" plain icon="el-icon-refresh-right" @click="resetAllFn">全部重置</el-button> -->
            <el-button type="primary" @click="showStudents">添加考生</el-button>
          </div>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index" width="50px"></el-table-column>
        <el-table-column label="比赛号码" prop="sitNum">
          <template slot-scope="{ row }">
            {{ row.sitNum || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="userName">
          <template slot-scope="{ row }">
            {{ row.userName || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="phone">
          <template slot-scope="{ row }">
            {{ row.phone || "-" }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="学校" prop="examinationUserSchoolName">
          <template slot-scope="{ row }">
            {{ row.examinationUserSchoolName || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="年级" prop="examinationUserGrade" :formatter="gradeFormat"></el-table-column>
        <el-table-column label="组别" prop="examinationUserLevel" :formatter="levelFormat"></el-table-column> -->
        <el-table-column label="操作" fixed="right" width="120px">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-refresh-right"
              size="small"
              style="margin-right: 12px;"
              @click="showEditDialog(scope.row)"
              >重置</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination> -->
    </el-card>

    <!-- 添加考生 -->
    <el-dialog title="添加考生"
      :visible.sync="stuVisible"
      width="30%"
      @close="handleCloseDialog">
      <el-form
        :model="addPlayerForm"
        label-width="120px"
        ref="addPlayerRef"
        :rules="addPlayerFormRules"
      >
      <el-form-item label="手机号" prop="phones">
          <el-input placeholder="请输入手机号(多个用,分割)" type="textarea" v-model="addPlayerForm.phones"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleToAdd">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import env from '@/http/env'
import { getNationalSpellerList, resetAllUser, removeExaminationRoomUser, addNationalUser } from '@/http/api'
export default {
  data () {
    return {
      dataList: [],
      total: 0,
      queryForm: {
        roomId: this.$route.query.id
      },
      addPlayerFormRules: {
        phones: [{ required: true, message: '请输入手机号（多账号,分割）', trigger: 'blur' }]
      },
      dict_group: this.$userInfo.dict_group(),
      dict_grade: this.$userInfo.getGradeData(),
      stuVisible: false,
      stuList: [],
      addPlayerForm: {
        roomId: this.$route.query.id,
        phones: '' // 复赛
      },
      userIds: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    handleToSearch () {
      this.queryForm.pageNum = 1
      this.getList()
    },
    handleToReset () {
      this.$refs.queryFormRef.resetFields()
      this.getList()
    },
    async getList () {
      getNationalSpellerList(this.queryForm).then(res => {
        this.dataList = res.data
        // this.total = res.data.total
      })
    },
    handleSizeChange (e) {
      this.queryForm.pageSize = e
      this.getList()
    },
    handleCurrentChange (e) {
      this.queryForm.pageNum = e
      this.getList()
    },
    async showEditDialog (row) {
      this.$confirm('是否重置该学生考场信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        removeExaminationRoomUser({ id: row.id }).then(res => {
          this.$message.success('已重置')
          this.handleToSearch()
        })
      }).catch(() => {
      })
    },
    resetAllFn () {
      this.$confirm('是否重置考场内所有学生?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        resetAllUser(this.queryForm.examinationId).then(res => {
          this.$message.success('已全部重置')
          this.handleToSearch()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消'
        // })
      })
    },
    levelFormat (row) {
      const level = row.examinationUserLevel || row.enrollmentLevel
      return level ? this.dict_group.find(item => Number(item.dictValue) === level).dictLabel : '-'
    },
    gradeFormat (row) {
      const grade = row.examinationUserGrade || row.grade
      return grade ? this.dict_grade.find(item => item.dictCode === grade).dictLabel : '-'
    },
    handleToSubmit () {
      this.$refs.dataFormRef.validate(async valid => {
        if (!valid) return false
        delete this.dataForm.dateRange
        const { data: res } = this.editType === 0 ? await this.$http.post('erp/nascc/certificate/create', this.dataForm) : await this.$http.put(`erp/nascc/certificate/edit/${this.editId}`, this.dataForm)
        if (res.code !== 0) {
          this.$message.error(res.message)
        } else {
          this.$message.success('保存成功')
          this.handleCloseDialog()
          this.getList()
        }
      })
    },
    handleToDetails (row) {
      this.$router.push({
        path: '/match_thing_manage/sspcn/certificateDetails',
        query: {
          id: row.id
        }
      })
    },
    daterangeChange (e) {
      if (e.length === 2) {
        this.dataForm.beginTime = e[0]
        this.dataForm.endTime = e[1]
      }
    },
    showStudents () {
      this.stuVisible = true
    },
    handleCloseDialog () {
      this.stuVisible = false
      this.$refs.addPlayerRef.resetFields()
    },
    handleSelectionChange (arr) {
      // console.log(arr)
      this.userIds = arr.map(item => item.userId)
    },
    exportTable () {
      var downLoadUrl = env.baseIP + 'en/excelSitExport'
      console.log('downLoadUrl', downLoadUrl)
      this.$downLoadFile.downLoadFileWithUrlNew(this, downLoadUrl, { roomId: this.queryForm.roomId })
    },
    handleToAdd () {
      addNationalUser(this.addPlayerForm).then(res => {
        this.$message.success('添加成功')
        this.handleCloseDialog()
        this.handleToSearch()
      })
    }
  }
}
</script>
<style lang="less" scoped>
.div_algin_right{
  text-align: right;
}
</style>
